import { createEntityAdapter } from '@reduxjs/toolkit';
import { transactionTrackerSlicePrefix } from './transactionTrackerSlice';
export const transactionTrackerAdapter = createEntityAdapter({
    selectId: (transaction) => transaction.hash,
    sortComparer: (a) => a.timestampMs,
});
export const transactionTrackerSelectors = transactionTrackerAdapter.getSelectors((state) => state[transactionTrackerSlicePrefix]);
//# sourceMappingURL=transactionTrackerAdapter.js.map